import { useCallback, useEffect, useMemo, useState } from 'react';
import api from 'services/api';
import { IMessage, IPrompt, IUseChat } from '../types';
import { systemMain as system } from 'v2/constants/systemsAI';
import { ChatServices } from 'v2/resources/services/chat';

const useChat = ({ promptParam, data }: IUseChat) => {
  const [prompt, setPrompt] = useState<IPrompt>({ prompt: '', data: '' });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [messages, setMessages] = useState<Array<IMessage>>([]);

  const handleSetMessages = ({ sender, text, isLink }: IMessage) => {
    setMessages((prevMessages) => [...prevMessages, { sender, text, isLink }]);
  };
  const submitPrompt = useCallback(async () => {
    try {
      setIsLoading(true);

      handleSetMessages({ sender: 'user', text: prompt.prompt, isLink: false });

      const response = await ChatServices.postChat({
        data: prompt.data ?? '',
        prompt: prompt.prompt,
        system,
      });

      handleSetMessages({
        sender: 'greenfy AI',
        text: response,
        isLink: response.includes('http'),
      });
    } catch (error) {
      handleSetMessages({
        sender: 'greenfy AI',
        text: 'Erro ao processar a solicitação.',
        isLink: false,
      });
    } finally {
      setIsLoading(false);
      setPrompt({ prompt: '', data: '' });
    }
  }, [prompt.prompt, prompt.data]);

  const handleSubmit = async (
    e:
      | React.FormEvent<HTMLFormElement>
      | React.KeyboardEvent<HTMLTextAreaElement>
      | React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();

    if (isLoading || !prompt.prompt.trim()) {
      return;
    }

    await submitPrompt();
  };

  const onPressEnter = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const extractLink = (text: string) => {
    const match = text.match(/https?:\/\/[^\s]+/);
    return match ? match[0] : null;
  };

  useEffect(() => {
    if (!promptParam) return;

    setPrompt({ prompt: promptParam, data: data ?? '' });
  }, [promptParam, data]);

  return {
    prompt,
    isLoading,
    messages,

    setPrompt,
    handleSubmit,
    onPressEnter,
    extractLink,
  };
};

export default useChat;
